import client from "@/client";

import { parseDashboardFilters } from "@/utils/api";

export const getCustomChartsData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    from,
    to,
    userId,
}: {
    simulationInstanceId?: string;
    scenarioInstanceId?: string;
    from: string;
    to: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${simulationInstanceId}/custom-charts?scenarioInstanceId=${scenarioInstanceId}&from=${from}&to=${to}&userId=${userId}`,
    );

    return data;
};

export const getCombinedCustomChartsData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    from,
    to,
    userId,
}: {
    simulationInstanceId?: string;
    scenarioInstanceId?: string;
    from: string;
    to: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${simulationInstanceId}/combined-custom-charts?scenarioInstanceId=${scenarioInstanceId}&from=${from}&to=${to}&userId=${userId}`,
    );

    return data;
};

//RecognitionScore, ProgressScore
export const getScoreData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    from,
    to,
    userId,
}: {
    simulationInstanceId?: string;
    scenarioInstanceId?: string;
    from: string;
    to: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/Scoring?scenarioInstanceId=${scenarioInstanceId}&sessionId=${simulationInstanceId}&from=${from}&to=${to}&userId=${userId}`,
    );

    return data;
};

export const getCombinedCustomTopStatsData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    from,
    to,
    userId,
}: {
    simulationInstanceId?: string;
    scenarioInstanceId?: string;
    from: string;
    to: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${simulationInstanceId}/combined-custom-top-stats?scenarioInstanceId=${scenarioInstanceId}&from=${from}&to=${to}&userId=${userId}`,
    );

    return data;
};

export const getTableData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    from,
    to,
    userId,
}: {
    simulationInstanceId?: string;
    scenarioInstanceId?: string;
    from: string;
    to: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${simulationInstanceId}/data-tables?scenarioInstanceId=${scenarioInstanceId}&userId=${userId}&from=${from}&to=${to}`,
    );

    return data;
};

export const triggerAnalytics = async ({
    simulationInstanceId,
}: {
    simulationInstanceId?: string;
}) => {
    const { data } = await client.post(`v1/analytics/${simulationInstanceId}`);

    return data;
};

export const getMapData = async (
    sessionId: string,
    scenarioInstanceId: string,
    start: number,
    end: number,
) => {
    const { data } = await client.get(
        `/v1/Map?sessionId=${sessionId}&scenarioInstanceId=${scenarioInstanceId}&start=${start}&end=${end}`,
    );

    return data;
};

export const getSessions = async (filters: any) => {
    const { data } = await client.get(`/v1/Session/sessions${parseDashboardFilters(filters)}`);

    return data;
};

export const getResultsData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/results?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

export const getCognitiveLoadBreakdownData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/cognitive-load-breakdown?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

export const getCrewCognitiveLoadData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/crew-cognitive-load?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

export const getCognitiveLoadWithStatsData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/cognitive-load-with-stats?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

//🚨change to color-phase-score
export const getColorPhaseScoreData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/phase-scoring?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

export const getSubDimensionsData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/sub-dimensions?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

export const getOverallPhaseScoreData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/overall-phase-score?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

export const getStatsSummaryWithDropdownData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/stats-summary-with-dropdown?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

// Endpoint to get all stats summary components data, except CircuitStats
export const getStatsSummaryData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/stats-summary?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

//CircuitStats
export const getCircuitStatsData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/circuit-stats?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

export const getFlightCircuitData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/flight-circuit?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

export const getEyeTrackingCanvasData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/eye-tracking-canvas?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

export const getGazeData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/gaze-data?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

export const getCycleContainerData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/cycle-container?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

export const getMultiFlightCircuitData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/multi-flight-circuit?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};

export const getPhaseSummaryData = async ({
    simulationInstanceId,
    scenarioInstanceId,
    userId,
}: {
    simulationInstanceId: string;
    scenarioInstanceId: string;
    userId: string;
}) => {
    const { data } = await client.get(
        `/v1/session/${scenarioInstanceId}/phase-summary?simulationInstanceId=${simulationInstanceId}&scenarioInstanceId=${scenarioInstanceId}&userId=${userId}`,
    );

    return data;
};
